<template>
  <div class="max-w-3xl">
    <div class="adthrive-header min-h-[280px] overflow-hidden"></div>
    <Ad mb-4 ad-slot="6966721074" />
    <h1 class="font-slab text-2xl text-brand-red">How fast am I going?</h1>
    <div space-y-10 mt-4>
      <LocationProblem v-if="locationError" :error="locationError" subject="your speed" alternative="" />
      <div v-else class="space-y-4">
        <p class="text-6xl sm:text-7xl font-bold tabular-nums">
          <template v-if="locationFormatted.speed.value">
            {{ locationFormatted.speed.value }}
          </template>
          <template v-else> &nbsp; </template>
        </p>
      </div>
      <div space-y-4>
        <!-- <h2 text-2xl font-semibold text-stone-500>Units</h2> -->
        <div space-x-lg>
          <Toggle color="red" :options="speedUnitOptions" v-model="locationFormatted.unitSettings.value.speedUnits" />
        </div>
      </div>
      <div v-if="!locationError" space-y-4 max-w-lg>
        <h2 text-2xl font-semibold text-stone-500>More Information</h2>
        <div grid grid-flow-dense grid-cols-2 gap-2>
          <DataItem
            label="Heading"
            :loading="!locationError && !locationFormatted.heading.value"
            :value="locationFormatted.heading.value"
          />
          <DataItem
            label="Direction"
            :loading="!locationError && !locationFormatted.direction.value"
            :value="locationFormatted.direction.value"
          />
          <DataItem
            label="Elevation"
            :value="locationFormatted.elevation.value"
            :units="locationFormatted.elevationUnits.value.name"
            :loading="loading && !locationError"
          />
          <DataItem label="Floor Level" :value="location.value?.floorLevel" />
          <DataItem
            label="Coordinates"
            :value="locationFormatted.coordinates.value"
            :loading="loading && !locationError"
            class="col-span-2"
          />
        </div>
      </div>
      <Ad ad-slot="1948746426" />
      <div class="prose">
        <h2 class="text-3xl font-semibold text-stone-500">What is this?</h2>
        <ContentRenderer v-if="page" :value="page" />
      </div>
    </div>
  </div>
</template>
<script setup>
const page = await useContent("/speed");

useSeoMeta({
  title: page.value.title,
  description: page.value.description,
  ogDescription: page.value.description,
});

defineOgImage({
  title: "How fast am I going?",
  subtitle: page.value.subtitle,
});

const { startWatching, stopWatching, location, error, loading } = useLocation();
const locationFormatted = useLocationFormatted(location, error);

startWatching();
// the user allowed location access again from LocationPermissionButton
onLocationEnabled(() => {
  stopWatching();
  startWatching();
});

// why the position couldn't be found (shown in place of the speed)
const locationError = computed(() => (isGeolocationError(error) ? error.value : null));

const speedUnitOptions = Object.entries(SPEED_UNITS).map(([key, value]) => ({
  label: value.name,
  value: key,
  title: value?.longName,
  description: value?.description || value?.longName,
}));
</script>
